import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext } from '../NavigationContext'
import { useNavigate } from 'react-router-dom'

function TextImRaum() {
  const [texts, setTexts] = useState([])
  const [loading, setLoading] = useState(true)
  const { setCurrentSlug } = useContext(NavigationContext)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchTexts = async () => {
      try {
        const response = await fetch('/wp-json/wp/v2/text-im-raum?_embed')
        const data = await response.json()
        
        if (Array.isArray(data)) {
          const formattedTexts = data.map(text => ({
            id: text?.id || '',
            title: text?.title?.rendered || '',
            featuredImage: text?._embedded?.['wp:featuredmedia']?.[0]?.source_url || '',
            slug: text?.slug || ''
          }))
          setTexts(formattedTexts)
        }
        
        setLoading(false)
      } catch (error) {
        console.error('Error fetching texts:', error)
        setLoading(false)
      }
    }

    fetchTexts()
  }, [])

  const handleTextClick = (slug) => {
    const fullPath = `text-im-raum/${slug}`
    setCurrentSlug(fullPath)
    navigate(`/${fullPath}`)
  }

  return (
    <main className="text-im-raum-page">
      <h1 className="page-title">Text im Raum</h1>
      
      <div className="text-im-raum-grid">
        {texts.map(text => (
          <article 
            key={text.id} 
            className="text-card"
            onClick={() => handleTextClick(text.slug)}
          >
            <div className="text-image">
              {text.featuredImage && (
                <img src={text.featuredImage} alt={text.title} />
              )}
              <div 
                className="text-title"
                dangerouslySetInnerHTML={{ __html: text.title }}
              />
            </div>
          </article>
        ))}
      </div>
    </main>
  )
}

export default TextImRaum